import { CDN_DOMAIN, CHAT_URL, CONTACT_TEL } from '@/config'
// 实名登记提示
export default function realRegisterTip (tip = '详情请致电客堂或在线咨询') {
  let container = document.getElementById('J-realRegister')
  if (!container) {
    container = document.createElement('div')
    const html = `<div class="com-real-register-mask"></div>\
                  <div class="com-real-register-container">\
                      <div class="com-real-register-close-btn">×</div>\
                      <div class="com-real-register-content">\
                          <div class="com-real-register-title">${tip}</div>\
                          <div class="com-real-register-btns">\
                              <a href="tel:${CONTACT_TEL}">\
                                  <img src="${CDN_DOMAIN}static/images/contact-tel.png" />\
                              </a>\
                              <a href="${CHAT_URL}">\
                                  <img src="${CDN_DOMAIN}static/images/contact-chat.png" />\
                              </a>\
                          </div>\
                      </div>\
                  </div>`
    container.setAttribute('class', 'com-real-register')
    container.setAttribute('id', 'J-realRegister')
    container.innerHTML = html
    document.body.appendChild(container)
    const closeBtn = container.querySelector('.com-real-register-close-btn')
    closeBtn.onclick = function () {
      container.style.display = 'none'
    }
  } else {
    container.style.display = 'block'
  }
}